module.exports = __webpack_public_path__ + "img/emblem.a39f42c5.svg";